<template>
	<div class="navbar">
		<hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
		<Softphone v-if="userInfo.agentCode && userInfo.deviceCode && isSoftphone && isChrome" :telPermission="telPermission" class="soft-phone" />
		<el-tooltip effect="dark" :content="isChrome ? '未配置工号和分机号' : '仅支持在Chrome浏览器85版本及以上使用'" placement="right">
			<svg-icon v-show="!userInfo.agentCode && !userInfo.deviceCode && isSoftphone || !isChrome" class="soft-phone-disable" icon-class="SoftphoneDisable" />
		</el-tooltip>
		<div class="right-menu">
			<template v-if="device!=='mobile'">
				<span class="version task" @click="handleApproval">
					<i class="el-icon-document"></i><el-badge v-show="approvalCount > 0" :value="approvalCount" />
				</span>
				<span class="version">{{StoreVersion}}</span>
				<EyePhone v-if="isShowPhone && $store.getters.userInfo.brandIdentify != brandName" />
				<search-tip />
				<help-tip />
				<network-tip />
				<information-tip />
				<server-type />
			</template>
			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<div class="avatar-wrapper">
					<img :src="userInfo.headImg" class="user-avatar" :onerror="`this.src='${cdnUrl}/static/images/avat.png'`" />
					<span class="user-name">{{decodeURI(name)}}</span>
					<i class="el-icon-caret-bottom" />
				</div>
				<el-dropdown-menu slot="dropdown">
					<router-link to="/personalInfo">
						<el-dropdown-item>
						{{ $t('navbar.profile') }}
						</el-dropdown-item>
					</router-link>
			
					<el-dropdown-item divided @click.native="logout">
						<span style="display:block;">{{ $t('navbar.logOut') }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Softphone from '@/components/Softphone';
import SearchTip from './SearchTip';
import NetworkTip from './NetworkTip';
import Hamburger from '@/components/Hamburger';
import ServerType from '@/components/ServerType';
import HelpTip from './HelpTip';
import InformationTip from './InformationTip';
import EyePhone from './EyePhone';

export default {
	computed: {
		...mapGetters([
			'sidebar',
			'avatar',
			'device',
			'name',
			'userInfo',
			'StoreVersion'
		])
	},
	data() {
		return {
			cdnUrl: process.env.VUE_APP_BASE_CDN,
			brandName: process.env.VUE_APP_BRANDNAME,
			isSoftphone: false,
			isShowPhone: false,
			isChrome: window.navigator.userAgent.indexOf("Chrome") > -1,
			telPermission: {},
			approvalCount:0,
			approvalTimer:null
			// version: {}
		}
	},
	created() {
		this.$api.menuSelectTree().then(response => {
			if(response.errcode != 0) return;
			for(const item of response.data) {
				if(item.viewUrl === 'code://auth-phone-eye') {
					this.isShowPhone = true;
				}
				if(item.viewUrl === 'code://auth-tel') {
					this.$api.apiPostCallAuxList({
						projectCode: this.userInfo.brandIdentify,
						auxType: 0
					}).then(res => {
						if(res.errcode != 0) return;
						this.$store.commit('telService/SET_SOFT_PHONE_AUX_LIST', res.data);
						this.isSoftphone = true;
						this.telPermission = item.nodes;
						this.$store.commit('telService/SET_TEL_ROLES', item.nodes);
						// this.$store.dispatch('telService/StoreTelRolesAction', item.nodes);
					});
				}
			}
		});
		this.getApprovalCount();
		this.approvalTimer = setInterval(() => {
			this.getApprovalCount();
		}, 5 * 1000);
		// this.$api.ocsGetVersionHistory().then(res=>{
		// 	if(res && res.errcode == 0){
		// 		this.version = res.data[0];
		// 	}
		// })
	},
	beforeDestroy(){
		clearInterval(this.approvalTimer);
	},
	methods: {
		toggleSideBar() {
			this.$store.dispatch('app/toggleSideBar')
		},
		handleApproval(){
			const waitApproval = this.$store.getters["permission/getIframeMap"]('c_p_assistant_approval');
			if(!waitApproval)  return this.$message.error('请先配置权限');
			// window.localStorage.setItem("c_p_assistant_home",'active=approvalWaiting');
			this.$router.push(waitApproval + '?active=approvalWaiting');
		},
		async logout() {
			await this.$store.dispatch('user/logout')
			// this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			// getLogout().then(res=>{
			//   let code = res.errcode
			//   if (code == 0) {
			//     // 删除token
			//     removeToken()
			//     this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			//     this.$message.success(res.errmsg)
			//   }
			// }).catch(() => {
			//   // this.$message.error(res.errmsg)
			// })
		},
		getApprovalCount(){
			this.$api.getApprovalListCountApi({
				candidateUserIds:[this.userInfo.userId],
				status:'2',
				type:'QA'
			}).then(response => {
				if(response.errcode != 0) return;
				this.approvalCount = response.data || 0;
			})
		}
	},
	components: {
		Softphone,
		SearchTip,
		NetworkTip,
		Hamburger,
		ServerType,
		HelpTip,
		InformationTip,
		EyePhone
	}
}
</script>

<style lang="scss" scoped>
.version {
	font-size: 16px;
	color: #888;
    line-height: 60px;
    transition: .2s;
    padding-bottom: 6px;
    user-select: none;
	vertical-align: top;
	margin-right: 5px;
	&.task {
		color: #000;
		font-size: 24px;
		margin-right: 10px;
		cursor: pointer;
	}
}
.navbar {
	height: 60px;
	// overflow: hidden;
	position: relative;
	background: #fff;
	box-shadow: 0 1px 4px rgba(0,21,41,.08);

	& > .hamburger-container {
		display: inline-block;
		vertical-align: top;
		line-height: 54px;
		width: 40px;
		height: 100%;
		cursor: pointer;
		transition: background .3s;
		-webkit-tap-highlight-color:transparent;

		&:hover {
			background: rgba(0, 0, 0, .025)
		}
	}

	& > .soft-phone {
		width: auto;
		height: 60px;
		display: inline-block;
		vertical-align: top;
	}

	& > .soft-phone-disable {
		outline: none;
		display: inline-block;
		width: 60px;
		height: 60px;
		background-image: url('../../assets/softphone-dis.png');
		background-repeat: no-repeat;
		background-size: 46px 40px;
		background-position: 0 10px;
		cursor: not-allowed;
	}

	& > .right-menu {
		// width: auto;
		vertical-align: top;
		height: 100%;
		line-height: 60px;
		float: right;

		&:focus {
			outline: none;
		}

		& > .right-menu-item {
			display: inline-block;
			height: 100%;

			&.hover-effect {
				cursor: pointer;
				transition: background .3s;

				&:hover {
					background: rgba(0, 0, 0, .025)
				}
			}
		}

		& > .avatar-container {
			margin-right: 30px;
			vertical-align: top;

			.avatar-wrapper {
				margin-top: 5px;
				position: relative;

				.user-avatar {
					cursor: pointer;
					width: 22px;
					height: 22px;
					border-radius: 50%;
					vertical-align: middle;
					margin-top: -16px;
				}

				.user-name{
					display: inline-block;
					font-size: 12px;
					color: #3C4353;
					vertical-align: top;
					margin-left: 5px;
					margin-top: -5px;
				}

				.el-icon-caret-bottom {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 15px;
					font-size: 18px;
				}
			}
		}
	}
}
</style>
